// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    window.onload = function() {
		onLoad();
	};


	/* SPLIT PRIMARY NAV */
	
	if(window.innerWidth > 700){
		let primaryNavi = document.getElementById('primary-nav');
		let primaryNav = document.getElementById('privary-navigation');
		let firstNav = document.getElementById('firstHalf_nav');
		let lastNav = document.getElementById('lastHalf_nav');
		let primaryNavLi = primaryNav.children;	
		let NavLiArray = Array.from(primaryNavLi);
		let splitNav = Math.round(NavLiArray.length / 2);
		let firstHalfElements = NavLiArray.slice(0, splitNav);
		let lastHalfElements = NavLiArray.slice(splitNav);
		
		firstNav && firstHalfElements.forEach(element => { firstNav.append(element);} );
		lastNav && lastHalfElements.forEach(element => { lastNav.append(element); });

		primaryNavi.remove();
	}

	/* PRIMARY NAV SUBMENU */

	let itemsMenu = document.querySelectorAll('.privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

	/* MOBILE BURGER MENU */

	const burgerMenu = document.getElementById('burger-menu');
	const burgerMenuBtn = document.getElementById('js-menu-trigger');
	const burgerClose = document.getElementById('js-menu-close');

	if(burgerMenuBtn) {
		burgerMenuBtn.addEventListener('click', () =>{
			burgerMenu.classList.add('open')
		});
		burgerClose.addEventListener('click', () =>{
			burgerMenu.classList.remove('open')
		});
	}

	/* LIGHTBOX */

	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open');
				document.body.classList.add('no-scroll');
			});

		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open');
				document.body.classList.remove('no-scroll');
			});
		}

		let allLbxWraps = document.querySelectorAll('.lightbox');

		for(const lbxWrap of allLbxWraps) {
			lbxWrap.addEventListener('click', (e) => {
				const innerWrap = lbxWrap.querySelector('.lightbox-wrap') ;
				if(!innerWrap.contains(e.target)) {
					allLbxWraps.forEach(el => el.classList.remove('open'));
					document.body.classList.remove('no-scroll');
				}
			})
		}

	};

	let dateInputs = document.querySelectorAll('input[type="date"]');
	if (dateInputs.length > 0) {
		dateInputs.forEach(function(input) {
			input.addEventListener('click', function() {
				this.classList.add('clicked');
			});
		});
	}


	/* for form title line animation */
	const allForms = document.querySelectorAll('.form-module-wrapper');
	if(allForms) {
		allForms.forEach(el=>el.classList.add('animate-fade'))
	}


	/* Accordions */ 

	const accordionBlocks = document.querySelectorAll('.accordion-block');
	if(accordionBlocks) {
		accordionBlocks.forEach((accordion) => {
			accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
				itemHead.addEventListener('click', (e) => {
					let currentParent = itemHead.parentNode;
					let currentCopyHeight = currentParent.getElementsByClassName('wrap')[0].clientHeight;
					let currentCopy = currentParent.getElementsByClassName('js-accordion-copy')[0]
					if(currentParent.classList.contains('open')){
						currentParent.classList.remove('open');
						currentCopy.style.height = '0';
					} else {
						currentParent.classList.add('open');
						currentCopy.style.height = currentCopyHeight + 'px';
					}
				});
			});
		});
	};


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

function onLoad() {
    if (!document.getElementById('gallery') &&
        document.getElementsByClassName('sitemap').length < 1 &&
        document.getElementsByClassName('terms-and-conditions').length < 1 &&
        document.getElementsByClassName('no-hero').length < 1) {
        scrollW();
    } else {
        document.getElementById('header').classList.add('scroll');
        changeSrc(document.querySelector('.js-scroll-logo').getElementsByTagName('img')[0]);
    }

    window.addEventListener('scroll', function () {
        scrollW();
		transformImages();
    });
}

function scrollW(){
	let st = window.pageYOffset || document.documentElement.scrollTop;
	const logo = document.querySelector('.js-scroll-logo');
	const header = document.getElementById('header');
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!header.classList.contains('down')){
				header.classList.add('down');
				header.classList.remove('up');
			}
			if(!header.classList.contains('scroll')){
				header.classList.add('scroll');
				changeSrc(logo.getElementsByTagName('img')[0]);
			};
		} else {
			// upscroll code
			if(!header.classList.contains('up')){
				header.classList.add('up');
				header.classList.remove('down');
			}
		}
	} else {
		if(header.classList.contains('up') || header.classList.contains('down')) {
			header.classList.remove('up');
			header.classList.remove('down');
		}
		if (!document.getElementById('gallery') &&
			document.getElementsByClassName('sitemap').length < 1 &&
			document.getElementsByClassName('terms-and-conditions').length < 1 &&
			document.getElementsByClassName('no-hero').length < 1) {
			if (header.classList.contains('scroll')) {
				header.classList.remove('scroll');
				changeSrc(logo.getElementsByTagName('img')[0]);
			}
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function changeSrc(elem) {
	let target = elem.getAttribute('data-scroll');
	let currentSrc = elem.getAttribute('src');

	elem.setAttribute('src', target);
	elem.setAttribute('data-scroll', currentSrc);
}


function transformImages() {
	let elements = document.querySelectorAll('.js-transform-img');
	let screenHeight = window.innerHeight;;
	if(elements && screen.width > 900) {
		elements.forEach(function(element, index) {
			let elementPosition = element.getBoundingClientRect().top;

			if (elementPosition < screenHeight && elementPosition > -element.offsetHeight) {
				let scrollPercentage = (screenHeight - elementPosition) / screenHeight;
				let translateY = Math.min(2.8, (-2.8 + scrollPercentage * 3.5)).toFixed(2);
				let scale = Math.max(1, 1.11 - 0.1 * scrollPercentage)
	
				element.style.transform = `translate3d(0px, ${translateY}%, 0px) scale3d(${scale}, ${scale}, 1)`;
			}
		});
	}
}